import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/images/completed-course-image.png'


const _withScopeId = n => (_pushScopeId("data-v-6fd52a7c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-flex tw-flex-col tw-gap-4" }
const _hoisted_2 = {
  key: 0,
  class: "dashboard-welcome remove-padding md:!tw-gap-4"
}
const _hoisted_3 = { class: "dashboard-welcome__text" }
const _hoisted_4 = { class: "body-text" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dashboard-welcome__img md:!tw-w-full" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "img-wrapper" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "md:!tw-w-full",
      src: _imports_0,
      width: "364",
      height: "144"
    })
  ])
], -1))
const _hoisted_6 = {
  key: 2,
  class: "courses__list all__courses"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "courses__title" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Completed Courses")
], -1))
const _hoisted_8 = {
  key: 0,
  class: "courses__card__list"
}
const _hoisted_9 = { class: "tw-flex tw-flex-col tw-justify-between tw-w-full tw-gap-3 tw-h-full" }
const _hoisted_10 = { class: "tw-flex tw-flex-col tw-w-full tw-gap-2 tw-h-full" }
const _hoisted_11 = { class: "courses__card__img" }
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "courses__card__title" }
const _hoisted_14 = { class: "courses__card__prefix !tw-w-full !tw-flex-col !tw-justify-between !tw-flex !tw-items-start" }
const _hoisted_15 = { class: "tw-flex tw-items-center tw-gap-2 tw-justify-start" }
const _hoisted_16 = { class: "tw-flex tw-items-center tw-gap-2 tw-justify-start" }
const _hoisted_17 = { class: "tw-flex tw-items-center tw-gap-2 tw-justify-start" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Text = _resolveComponent("Text")!
  const _component_Button = _resolveComponent("Button")!
  const _component_CalendarIcon = _resolveComponent("CalendarIcon")!
  const _component_MapMarkerBlueIcon = _resolveComponent("MapMarkerBlueIcon")!
  const _component_MapMarkerYellowIcon = _resolveComponent("MapMarkerYellowIcon")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_CommonLoader = _resolveComponent("CommonLoader")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    (!_ctx.filterListOfEnrollCourse?.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h3", null, _toDisplayString(_ctx.filterListOfEnrollCourse?.length ? _ctx.title : _ctx.titleEmptyState), 1),
            _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.filterListOfEnrollCourse?.length ? _ctx.text : _ctx.textEmptyState), 1),
            _createVNode(_component_Text, {
              variant: "p",
              textColor: "rgba(12, 15, 74, 0.5)",
              class: "md:!tw-text-center"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Don't miss out on the opportunity to expand your knowledge and skills with our diverse selection of courses.")
              ]),
              _: 1
            }),
            _createVNode(_component_Text, {
              variant: "p",
              textColor: "rgba(12, 15, 74, 0.5)"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Happy learning!")
              ]),
              _: 1
            })
          ]),
          _hoisted_5
        ]))
      : _createCommentVNode("", true),
    (!_ctx.filterListOfEnrollCourse?.length)
      ? (_openBlock(), _createBlock(_component_Button, {
          key: 1,
          label: "VIEW ALL COURSEs",
          class: "!tw-w-[342px]",
          onClick: _ctx.routeToAllCourses
        }, null, 8, ["onClick"]))
      : _createCommentVNode("", true),
    (_ctx.filterListOfEnrollCourse?.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _hoisted_7,
          (!_ctx.loading && _ctx.filterListOfEnrollCourse?.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filterListOfEnrollCourse, (items, index) => {
                  return (_openBlock(), _createBlock(_component_v_card, {
                    class: "courses__card completed_card",
                    key: index
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("section", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("img", {
                              class: "",
                              cover: "",
                              src: 
                    require('@/assets/images/course/' +
                      items?.course?.thumbnail)
                  
                            }, null, 8, _hoisted_12)
                          ]),
                          _createElementVNode("h5", _hoisted_13, _toDisplayString(items?.course?.title), 1),
                          _createElementVNode("div", _hoisted_14, [
                            _createVNode(_component_Text, {
                              class: "course-ellipsis",
                              textColor: "rgba(12,15,74,0.5)",
                              variant: "span",
                              lineHeight: "20px"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(items?.course?.about), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createElementVNode("div", _hoisted_15, [
                              _createVNode(_component_CalendarIcon, { class: "tw-min-w-[11px] tw-min-h-[13px]" }),
                              _createVNode(_component_Text, {
                                variant: "span",
                                textColor: "rgba(12, 15, 74, 0.5)"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.formatDate(
                      items?.userCourseSchedules[0]?.courseSchedule?.startDate
                    )), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _createElementVNode("div", _hoisted_16, [
                              _createVNode(_component_MapMarkerBlueIcon, { class: "tw-min-w-[11px] tw-min-h-[13px]" }),
                              _createVNode(_component_Text, {
                                variant: "span",
                                textColor: "rgba(12, 15, 74, 0.5)"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(items?.courseMode), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _createElementVNode("div", _hoisted_17, [
                              _createVNode(_component_MapMarkerYellowIcon, { class: "tw-min-w-[11px] tw-min-h-[13px]" }),
                              _createVNode(_component_Text, {
                                variant: "span",
                                textColor: "rgba(12, 15, 74, 0.5)",
                                lineHeight: "20px"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(items?.userCourseSchedules[0]?.courseSchedule?.address), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ])
                          ])
                        ]),
                        _createVNode(_component_Button, {
                          onClick: ($event: any) => (_ctx.viewCourseDetails(items?.course?.id, items?.id)),
                          variant: "secondary",
                          label: "view full course details"
                        }, null, 8, ["onClick"])
                      ])
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]))
            : (_openBlock(), _createBlock(_component_CommonLoader, {
                key: 1,
                loading: _ctx.loading
              }, null, 8, ["loading"]))
        ]))
      : _createCommentVNode("", true)
  ]))
}